<template>
  <main>

    <div class="path">
      <i class="el-icon-caret-right"></i>系统信息
      <i class="el-icon-arrow-right"></i>&nbsp;用户列表
    </div>

    <br>
    <div class="content-wrapper">
      <el-form label-width="120px">
        <div class="item-wrapper">
          <el-form-item label="用户手机号码" style="margin-bottom: 0px;">
            <el-input v-model="phone" type="text" clearable
                      style="width: 320px">
              <el-button slot="append" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <section class="content_wrapper">
      <el-table
        :data="tableData.list"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ (currentPage-1) * pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          prop="loginPhone"
          label="用户手机"
          width="160">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱地址"
          width="250">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="注册时间">
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>

    </section>

  </main>
</template>

<style>
  .el-table .success-cell {
    background: #F0F9EB;
    font-weight: bold;
  }
</style>

<script>
import {
  reqFindAllCustomers
} from '@/api'

export default {
  name: 'AllCustomers',

  data() {
    return {
      tableData: {},
      loading: true,
      phone: '',
      currentPage: 1,
      total: 0,
      pageSize: 50
    }
  },

  async mounted () {
    const result = await reqFindAllCustomers(this.phone, this.currentPage)
    if (result.code === 0) {
      this.tableData = result.data
      this.loading = false
      this.total  = result.data.total
      this.pageSize  = result.data.pageSize
    } else {
      this.$message.error('数据查询失败，错误信息: ' + result.message)
    }
  },

  methods: {
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      const result = await reqFindAllCustomers(this.phone, this.currentPage)
      if (result.code === 0) {
        this.tableData = result.data
        this.total  = result.data.total
        this.pageSize  = result.data.pageSize
        this.loading = false
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    handleQuery () {
      this.tableData = {}
      this.handleCurrentChange(1)
    }
  },

  computed: {
  }

}
</script>

<style scoped>

  main {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .content_wrapper {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px auto;
  }

  .search_bar {
    width: 800px;
    margin: 20px auto;
  }

  .search_result_tip {
    color: #909399;
    font-size: 14px;
    line-height: 50px;
  }

  .btn {
    width: 140px;
    margin: 20px auto;
  }

  .path {
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    font-size: 14px;
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/pages/AdminCenter/AllCustomers/AllCustomers.vue